import { useForm, FormProvider } from "react-hook-form";
import { useDispatch } from "react-redux";
import React from "react";
import { confirmWithdraw, updateWithdrawFormData } from "../../payments/WithdrawActions";
import { t } from "../../i18n";
import { BrandButton } from "../buttons/buttons";
import { PriorityType } from "../../http/Types";
import "./CryptoDetails.scss";
import CryptoAddressInput from "./CryptoAddressInput";
import CryptoAmountSelector from "./CryptoAmountSelector";

export interface CryptoFormData {
  recipientAddress: string;
  amount: string;
  destinationTag?: string;
  notesTag?: string;
  priority?: PriorityType;
}

const CryptoDetails: React.FC = () => {
  const dispatch = useDispatch();
  const methods = useForm<CryptoFormData>({
    mode: "onChange",
  });

  const {
    handleSubmit,
    formState: { isValid },
  } = methods;

  const onSubmit = handleSubmit((data) => {
    dispatch(updateWithdrawFormData(data));
    dispatch(confirmWithdraw(data.priority));
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit} className="crypto-details-container">
        <CryptoAddressInput />
        <CryptoAmountSelector />

        <div className="row mt-4">
          <div className="col-12">
            <BrandButton type="submit" className="btn btn-cta full-width large" disabled={!isValid}>
              {t("cashier.review")}
            </BrandButton>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default CryptoDetails;
